<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                Thank you for contacting us
            </h1>
        </div>
        <div class="grid-container pad-top">
            <div class="grid-x grid-padding-x pad-top pad-bottom">
                <div class="cell small-12 medium-6">
                    <p class="lead">We will get back in touch with you soon</p>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'ContactThankYou',
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Contact/ContactThankYou.vue